module.exports = __webpack_public_path__ + "static/media/guestListIcon.a250cf4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboardV4/guestListIcon.svg
// module id = 757
// module chunks = 53